export default __webpack_public_path__ + "static/media/az-signature.56d47d7c.png";